import { ENV } from "constant/app";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import semverLt from "semver/functions/lt";
import { Table, Column } from "ui/table";
import { Box } from "view/layout/box";

const { APP_NAME } = ENV;

class PlayerVersionTable extends React.PureComponent {
  static get propTypes() {
    return {
      stats: PropTypes.array.isRequired,
    };
  }

  static _sortVersion(first, second, order) {
    const multiplier = order === "desc" ? 1 : -1;
    if (first === "no_ver") {
      return multiplier;
    }
    if (second === "no_ver") {
      return -multiplier;
    }
    try {
      return (semverLt(first, second) ? 1 : -1) * multiplier;
    } catch (e) {
      return 0;
    }
  }

  constructor() {
    super();
  }

  _formatVersion(version) {
    return version === "no_ver" ? "No Version" : version;
  }

  _formatPlayerCount(count, row) {
    if (APP_NAME === "zeus") {
      return count;
    }
    const playerVersion = row.version || "no_ver";
    return (
      <Link
        title={`Devices with version ${playerVersion}`}
        to={`/devices?current_version=${playerVersion}`}
      >
        {count}
      </Link>
    );
  }

  render() {
    const { stats } = this.props;

    return (
      <Box title="Player Versions">
        <Table
          data={stats}
          defaultSorted={[{ dataField: "version", order: "desc" }]}
          hover={true}
          keyField="version"
          pagination={true}
        >
          <Column
            dataField="version"
            dataFormat={this._formatVersion}
            dataSort={true}
            isKey={true}
            key="version"
            sortFunc={PlayerVersionTable._sortVersion}
          >
            Version
          </Column>
          <Column
            dataField="count"
            dataFormat={this._formatPlayerCount}
            dataSort={true}
            key="count"
          >
            Player Count
          </Column>
        </Table>
      </Box>
    );
  }
}

export { PlayerVersionTable };
